<template>
  <div class="login-page-wrapper">
    <!-- 装饰背景光晕 -->
    <div class="bg-glow-layer" aria-hidden="true">
      <div class="bg-blob bg-blob-blue"></div>
      <div class="bg-blob bg-blob-orange"></div>
      <div class="bg-grid-overlay"></div>
    </div>

    <!-- 主内容-->
    <div class="main-content" style="justify-content:center; padding:48px 24px;">
      <div class="auth-split-shell">
        <AuthBrandPanel />

        <!-- 右侧登录表单卡片 -->
        <div class="login-form-container">
          <el-card class="login-card" shadow="always">
            <!-- 关闭按钮 -->
<!--            <el-icon class="close-btn" @click="$router.push('/home')">-->
<!--              <Close />-->
<!--            </el-icon>-->

            <!-- 表单主体 -->
            <div class="login-body">
              <div class="login-form-wrapper">
                <!-- 顶部登录提示 - 动态标题 -->
                <div class="login-header">
                  <div class="header-eyebrow">欢迎回来</div>
                  <h3>{{ getLoginTitle() }}</h3>
                  <p class="header-sub">登录以继续使用易印工具</p>
                </div>

                <!-- 账号登录表单 -->
                <el-form
                    v-if="loginMethod === 'account'"
                    ref="accountLoginFormRef"
                    :model="accountLoginForm"
                    @submit.prevent="handleAccountLogin"
                    class="login-form"
                >
                  <el-form-item prop="account">
                    <el-input
                        v-model="accountLoginForm.account"
                        placeholder="请输入用户名或手机号"
                        size="large"
                        clearable
                        class="login-elegant-input"
                        autocomplete="off"
                        @input="clearAccountErrors"
                        @focus="clearAccountErrors"
                    >
                      <template #prefix>
                        <el-icon><User /></el-icon>
                      </template>
                    </el-input>

                    <!-- 账号错误提示 -->
                    <div v-if="accountError" class="error-message">
                      <el-icon><WarningFilled /></el-icon>
                      <span>{{ accountError }}</span>
                    </div>

                  </el-form-item>

                  <el-form-item prop="password">
                    <el-input
                        v-model="accountLoginForm.password"
                        type="password"
                        placeholder="请输入密码"
                        size="large"
                        show-password
                        class="login-elegant-input"
                        autocomplete="new-password"
                        @input="clearPasswordErrors"
                        @focus="clearPasswordErrors"
                    >
                      <template #prefix>
                        <el-icon><Lock /></el-icon>
                      </template>
                    </el-input>

                    <!-- 密码错误提示 -->
                    <div v-if="passwordError" class="error-message">
                      <el-icon><WarningFilled /></el-icon>
                      <span>{{ passwordError }}</span>
                    </div>

                  </el-form-item>

                  <!-- 忘记密码链接 -->
                  <div class="login-footer-link">
                    <el-link type="info" class="forgot-password" @click="$router.push('/updatePassword')">忘记密码?</el-link>
                  </div>

                  <!-- 登录按钮 -->
                  <el-form-item>
                    <el-button
                        type="primary"
                        size="large"
                        native-type="submit"
                        class="login-btn"
                        style="background:#2F5BFF !important; border-color:#2F5BFF !important;"
                        :loading="loading"
                    >
                      登录
                    </el-button>
                  </el-form-item>

                </el-form>

                <!-- 手机登录表单 -->
                <el-form
                    v-if="loginMethod === 'phone'"
                    ref="phoneLoginFormRef"
                    :model="phoneLoginForm"
                    @submit.prevent="handlePhoneLogin"
                    class="login-form"
                >
                  <el-form-item prop="phone">
                    <el-input
                        v-model="phoneLoginForm.phone"
                        placeholder="请输入手机号"
                        size="large"
                        clearable
                        class="login-elegant-input"
                        autocomplete="off"
                        @input="clearPhoneErrors"
                        @focus="clearPhoneErrors"
                    >
                      <template #prefix>
                        <el-icon><Iphone /></el-icon>
                      </template>
                    </el-input>
                    <!-- 手机号错误提示 -->
                    <div v-if="phoneError" class="error-message">
                      <el-icon><WarningFilled /></el-icon>
                      <span>{{ phoneError }}</span>
                    </div>
                  </el-form-item>

                  <!-- 短信验证码 -->
                  <el-form-item prop="captcha">
                    <el-input
                        v-model="phoneLoginForm.captcha"
                        placeholder="请输入验证码"
                        size="large"
                        class="login-elegant-input"
                        autocomplete="off"
                        @input="clearCaptchaErrors"
                        @focus="clearCaptchaErrors"
                    >
                      <template #prefix>
                        <el-icon><Message /></el-icon>
                      </template>
                      <template #suffix>
                        <el-button
                            link
                            class="captcha-btn"
                            :disabled="captchaCooldown > 0"
                            @click="sendCaptcha"
                        >
                          {{ captchaCooldown > 0 ? `${captchaCooldown}秒后重试` : '获取验证码' }}
                        </el-button>
                      </template>
                    </el-input>
                    <!-- 验证码成功提示 -->
                    <div v-if="captchaSuccess" class="success-message">
                      <el-icon><SuccessFilled /></el-icon>
                      <span>{{ captchaSuccess }}</span>
                    </div>
                    <!-- 验证码错误提示 -->
                    <div v-if="captchaError" class="error-message">
                      <el-icon><WarningFilled /></el-icon>
                      <span>{{ captchaError }}</span>
                    </div>
                  </el-form-item>

                  <!-- 忘记密码链接 -->
                  <div class="login-footer-link">
                    <el-link type="info" class="forgot-password" @click="$router.push('/updatePassword')">忘记密码?</el-link>
                  </div>

                  <el-form-item>
                    <el-button
                        type="primary"
                        size="large"
                        native-type="submit"
                        class="login-btn"
                        style="background:#2F5BFF !important; border-color:#2F5BFF !important;"
                        :loading="loading"
                    >
                      登录
                    </el-button>
                  </el-form-item>

                </el-form>

                <!-- 微信登录表单 -->
                <div v-if="loginMethod === 'wechat'" class="wechat-login-container">

                  <!-- 正常二维码显示 -->
                  <div v-if="wechatQrCodeUrl && !isQrCodeExpired" class="wechat-qrcode">
                    <img :src="wechatQrCodeUrl" alt="微信登录二维码">
                    <p class="tip">请使用微信扫一扫登录</p>
                  </div>

                  <!-- 二维码过期提示（遮罩直接覆盖在二维码上方） -->
                  <div v-else-if="isQrCodeExpired" class="qr-expired-prompt">
                    <div class="expired-qrcode">
                      <!-- 灰色二维码图片 -->
                      <img :src="wechatQrCodeUrl" alt="已过期的微信登录二维码" class="expired-img">
                      <!-- 点击遮罩层刷新 -->
                      <div class="expired-mask" @click="refreshQrCode">
                        <div class="expired-content">
                          <el-icon class="expired-icon"><WarningFilled /></el-icon>
                          <p class="expired-text">二维码已过期</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 加载占位 -->
                  <div v-else-if="wechatQrError" class="qr-error">
                    <p>{{ wechatQrError }}</p>
                    <el-button text type="primary" @click="handleWechatLogin">重新加载</el-button>
                  </div>
                  <div v-else class="loading-qrcode">

                  </div>
                </div>

                <!-- 注册链接 -->
                <div v-if="loginMethod !== 'wechat'" class="register-link">
                  <span>还没有账号？</span>
                  <el-link type="primary" @click="$router.push('/register')" style="font-style: italic;">去注册</el-link>
                </div>

                <!-- 登录方式选择 -->
                <div class="login-method-wrapper">
                  <div class="login-method-label">其他登录方式</div>
                  <div class="login-method-container">
                    <div class="login-method-tabs">
                      <!-- 手机登录图标 - 当不是手机登录时显示 -->
                      <el-button
                          v-if="loginMethod !== 'phone'"
                          :class="['method-button', 'icon-only']"
                          @click="loginMethod = 'phone'"
                          size="large"
                          text
                      >
                        <svg t="1761617897590" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5998" width="28" height="28">
                          <path d="M724.350707 63.353535H297.787475C253.310707 63.353535 217.212121 99.555556 217.212121 143.928889v736.245656c0 44.476768 36.20202 80.575354 80.575354 80.575354h426.563232c44.476768 0 80.575354-36.20202 80.575354-80.575354V143.928889c0-44.476768-36.098586-80.575354-80.575354-80.575354zM297.787475 104.727273h426.563232c21.617778 0 39.201616 17.583838 39.201616 39.201616V179.717172H258.585859v-35.788283C258.585859 122.311111 276.169697 104.727273 297.787475 104.727273zM258.585859 221.090909h505.069899v527.72202H258.585859V221.090909z m465.764848 698.285253H297.787475c-21.617778 0-39.201616-17.583838-39.201616-39.201617v-89.987878h505.069899v89.987878c-0.103434 21.617778-17.687273 39.201616-39.305051 39.201617z m0 0" fill="#efb336" p-id="5999"></path>
                          <path d="M435.975758 149.721212h150.083232c8.274747 0 14.99798-6.723232 14.99798-14.99798 0-8.274747-6.723232-14.99798-14.99798-14.997979H435.975758c-8.274747 0-14.99798 6.723232-14.99798 14.997979 0 8.274747 6.723232 14.99798 14.99798 14.99798z m0 0M457.490101 855.660606c0 19.135354 10.214141 36.822626 26.789495 46.403232 16.575354 9.567677 37.003636 9.567677 53.57899 0a53.575111 53.575111 0 0 0 26.789495-46.403232c0-29.595152-23.983838-53.57899-53.57899-53.57899-29.595152 0-53.57899 23.983838-53.57899 53.57899z m0 0" fill="#efb336" p-id="6000"></path>
                        </svg>
                      </el-button>

                      <!-- 微信登录图标 - 当不是微信登录时显示 -->
                      <el-button
                          v-if="loginMethod !== 'wechat'"
                          :class="['method-button', 'icon-only']"
                          @click="handleWechatLogin"
                          :disabled="isWechatLoginLoading"
                          size="large"
                          text
                      >
                        <svg t="1761617723278" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4874" width="28" height="28">
                          <path d="M1024 619.52c0-143.36-138.24-256-307.2-256s-307.2 112.64-307.2 256 138.24 256 307.2 256c30.72 0 61.44-5.12 92.16-10.24l97.28 51.2-25.6-76.8c87.04-51.2 143.36-128 143.36-220.16z m-414.72-40.96c-30.72 0-51.2-20.48-51.2-51.2s20.48-51.2 51.2-51.2 51.2 20.48 51.2 51.2c0 25.6-25.6 51.2-51.2 51.2z m209.92 0c-30.72 0-51.2-20.48-51.2-51.2s20.48-51.2 51.2-51.2 51.2 20.48 51.2 51.2c0 25.6-25.6 51.2-51.2 51.2z" fill="#22c55e" p-id="4875"></path>
                          <path d="M358.4 609.28c0-158.72 153.6-286.72 348.16-286.72h15.36c-40.96-133.12-179.2-235.52-353.28-235.52-204.8 0-368.64 138.24-368.64 307.2 0 107.52 66.56 204.8 168.96 256l-30.72 92.16L256 686.08c35.84 10.24 71.68 15.36 112.64 15.36h10.24c-15.36-30.72-20.48-61.44-20.48-92.16z m138.24-414.72c35.84 0 66.56 30.72 66.56 66.56s-30.72 66.56-66.56 66.56C460.8 322.56 430.08 291.84 430.08 256S460.8 194.56 496.64 194.56zM245.76 322.56c-35.84 0-61.44-30.72-61.44-66.56s30.72-66.56 66.56-66.56 61.44 30.72 61.44 66.56-30.72 66.56-66.56 66.56z" fill="#22c55e" p-id="4876"></path>
                        </svg>
                      </el-button>

                      <!-- 账号登录图标 - 当不是账号登录时显示 -->
                      <el-button
                          v-if="loginMethod !== 'account'"
                          :class="['method-button', 'icon-only']"
                          @click="loginMethod = 'account'"
                          size="large"
                          text
                      >
                        <svg t="1761617971743" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7068" width="28" height="28">
                          <path d="M522.24 61.44c112.64 0 204.8 92.16 204.8 204.8s-92.16 204.8-204.8 204.8-204.8-92.16-204.8-204.8 92.16-204.8 204.8-204.8m0-51.2c-143.36 0-256 112.64-256 256s112.64 256 256 256 256-112.64 256-256-112.64-256-256-256z" fill="#7dc5eb" p-id="7069"></path>
                          <path d="M512 471.04v51.2c71.68 0 133.12 10.24 168.96 15.36 15.36 0 30.72 10.24 46.08 15.36 10.24 5.12 15.36 5.12 25.6 10.24 163.84 76.8 220.16 209.92 199.68 307.2-10.24 40.96-35.84 92.16-87.04 97.28H153.6c-46.08 0-71.68-46.08-81.92-87.04-20.48-97.28 30.72-235.52 204.8-317.44 71.68-25.6 148.48-35.84 235.52-35.84V471.04m0 0c-76.8 0-168.96 10.24-256 40.96-337.92 158.72-276.48 501.76-102.4 501.76h716.8c179.2-15.36 220.16-353.28-102.4-501.76-5.12 0-46.08-15.36-76.8-20.48-46.08-10.24-107.52-20.48-179.2-20.48z" fill="#7dc5eb" p-id="7070"></path>
                        </svg>
                      </el-button>
                    </div>
                  </div>
                </div>

                <!-- 用户协议和隐私政策 -->
                <div v-if="loginMethod !== 'wechat'" class="agreement">
                  <div class="agreement-content">
                    <el-checkbox
                        v-model="agreeToTerms"
                        class="agree-checkbox"
                        @click.stop
                    >
                      我已阅读并同意
                    </el-checkbox>
                    <div class="agreement-links">
                      <el-link type="primary" @click="showTermsDialog">《用户协议》</el-link>
                      <span>和</span>
                      <el-link type="primary" @click="showPrivacyDialog">《隐私政策》</el-link>
                    </div>
                  </div>
                </div>
                <div v-if="loginMethod === 'wechat'" class="agreement">
                  登录即表示同意
                  <el-link type="primary" @click="showTermsDialog">《用户协议》</el-link>
                  和
                  <el-link type="primary" @click="showPrivacyDialog">《隐私政策》</el-link>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <el-footer class="login-footer" height="auto">
      <div class="footer-glow footer-glow-blue" aria-hidden="true"></div>
      <div class="footer-glow footer-glow-orange" aria-hidden="true"></div>
      <div class="footer-content">
        <div class="footer-main">
          <div class="footer-sections">
            <!-- 网站介绍 -->
            <div class="footer-section">
              <h4 class="section-title footer-logo-text">易印工具</h4>
              <p class="footer-desc">
                专业的印前设计工具，让设计更加高效精准。我们致力于为各行业提供最优质的印前解决方案。
              </p>
            </div>

            <!-- 联系方式 -->
            <div class="footer-section">
              <h4 class="section-title">联系方式</h4>
              <div class="contact-info">
                <div class="contact-item">
                  <el-icon><Message /></el-icon>
                  <span>3052594895@qq.com</span>
                </div>
                <div class="contact-item">
                  <el-icon><Phone /></el-icon>
                  <span>18925330037</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 底部版权信息 -->
          <div class="footer-bottom">
            <div class="copyright-section">
              <div class="copyright-text">
                © 2026 中山市易印网络科技有限公司.保留所有权利.
              </div>

            </div>
            <div class="certification-info">
              <div class="beian-container">
                <img src="/eprinttools-files/front-end/police.png" alt="公安备案图标" class="beian-icon">
                <a href="http://www.beian.gov.cn" target="_blank" class="beian-link">
                  粤公网安备 44200002443702号
                </a>
                <span class="divider">|</span>
                <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
                  粤ICP备16014837号
                </a>
              </div>
              <div class="legal-links">
                <a href="/privacyPolicy" @click.prevent="showPrivacyDialog" class="legal-link">隐私政策</a>
                <span class="divider">|</span>
                <a href="/userAgreement" @click.prevent="showTermsDialog" class="legal-link">用户协议</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-footer>
  </div>

  <!-- 服务条款弹窗 -->
  <el-dialog
      v-model="termsDialogVisible"
      :title="null"
      width="60%"
      top="8vh"
      class="policy-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <template #header>
      <div class="dialog-header">
        <div class="dialog-header-icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 2v6h6M9 13h6M9 17h6" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <h3>用户协议</h3>
          <p>请仔细阅读以下条款</p>
        </div>
      </div>
    </template>
    <div class="dialog-content" v-html="termsContent"></div>
    <template #footer>
    <span class="dialog-footer">
      <el-button type="primary" @click="termsDialogVisible = false">关闭</el-button>
    </span>
    </template>
  </el-dialog>

  <!-- 隐私政策弹窗 -->
  <el-dialog
      v-model="privacyDialogVisible"
      :title="null"
      width="60%"
      top="8vh"
      class="policy-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"

  >
    <template #header>
      <div class="dialog-header">
        <div class="dialog-header-icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 12l2 2 4-4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <h3>隐私政策</h3>
          <p>我们如何保护您的个人信息</p>
        </div>
      </div>
    </template>
    <div class="dialog-content" v-html="privacyContent"></div>
    <template #footer>
    <span class="dialog-footer">
      <el-button type="primary" @click="privacyDialogVisible = false">关闭</el-button>
    </span>
    </template>
  </el-dialog>

  <BindPhoneDialog
      v-model="bindPhoneDialogVisible"
      :session-id="currentSessionId"
      @bind-success="handleBindSuccess"
  />
</template>

<script setup>
import { ref, reactive, watch, computed, onUnmounted, onBeforeUnmount } from 'vue'
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router'
import { ElMessage } from 'element-plus'
import { Picture, Close, Message, Iphone, Star, SuccessFilled, WarningFilled, ChatDotSquare, Avatar } from '@element-plus/icons-vue'
import request from '@/utils/request'
import { useAuthState } from '@/stores/authState'
import BindPhoneDialog from '@/components/BindPhoneDialog.vue'
import AuthBrandPanel from '@/components/auth/AuthBrandPanel.vue'
import { TERMS_CONTENT, PRIVACY_CONTENT } from '@/constants/authContent'
import { validateAccount, validatePassword, validatePhone, validateCaptcha, startCountdown } from '@/utils/authValidators'

const { setToken } = useAuthState()

const router = useRouter()
const route = useRoute() // 获取当前路由信息

// 登录方式
const loginMethod = ref('account') // account/phone/WeChat

// 获取登录标题
const getLoginTitle = () => {
  switch (loginMethod.value) {
    case 'account':
      return '账号登录'
    case 'phone':
      return '手机登录'
    case 'wechat':
      return '微信登录'
    default:
      return '登录'
  }
}

// 弹窗控制变量
const termsDialogVisible = ref(false)
const privacyDialogVisible = ref(false)

// 添加绑定手机弹窗相关变量
const bindPhoneDialogVisible = ref(false)

// 用户协议内容
const termsContent = ref(TERMS_CONTENT)
// 隐私政策内容
const privacyContent = ref(PRIVACY_CONTENT)

// 显示对话框的方法
const showTermsDialog = () => {
  termsDialogVisible.value = true
}

const showPrivacyDialog = () => {
  privacyDialogVisible.value = true
}

// 同意协议相关的变量
const agreeToTerms = ref(false)
const agreeError = ref(false)

// 账号登录表单数据
const accountLoginForm = reactive({
  account: '',
  password: ''
})

// 手机登录表单数据
const phoneLoginForm = reactive({
  phone: '',
  captcha: ''
})

const emailLoginFormRef = ref(null)
const phoneLoginFormRef = ref(null)
const loading = ref(false)
const captchaCooldown = ref(0)      // 手机验证码发送冷却时间
const emailCaptchaCooldown = ref(0) // 邮箱验证码发送冷却时间

// 账号登录错误提示状态
const accountError = ref('')
const passwordError = ref('')

// 手机登录错误提示状态
const phoneError = ref('')
const captchaError = ref('')
const captchaSuccess = ref('')

const wechatQrCodeUrl = ref(''); // 微信二维码URL
const wechatQrError = ref(''); // 微信二维码加载错误
const currentSessionId = ref(''); // 当前会话ID
const isQrCodeExpired = ref(false); // 二维码过期状态
const isWechatLoginLoading = ref(false); // 微信登录加载状态

// 轮询相关变量
let pollingTimer = null;
const activePollingSessions = ref(new Set()); // 活跃的轮询会话

// 清除邮箱错误提示
const clearEmailErrors = () => {
  emailError.value = '';
}

// 清除密码错误提示
const clearPasswordErrors = () => {
  passwordError.value = '';
}

// 清除账号错误提示
const clearAccountErrors = () => {
  accountError.value = '';
}

// 清除手机号错误提示
const clearPhoneErrors = () => {
  phoneError.value = '';
}

// 清除手机验证码错误提示
const clearCaptchaErrors = () => {
  captchaError.value = '';
  captchaSuccess.value = '';
}

// 验证账号格式

// 验证密码

// 验证手机号格式

// 验证验证码

// 清理轮询函数
const clearPolling = () => {
  // console.log('清理轮询定时器:', pollingTimer);
  if (pollingTimer) {
    clearTimeout(pollingTimer);
    pollingTimer = null;
  }
}

// 清理所有轮询会话
const clearAllPolling = () => {
  clearPolling();
  activePollingSessions.value.clear();
  // console.log('所有轮询已清理');
}

// 倒计时函数

// 处理账号登录
const handleAccountLogin = async () => {
  if (!agreeToTerms.value) {
    ElMessage.error('请先阅读并同意用户协议和隐私政策')
    return
  }

  // 清除之前的错误信息
  clearAccountErrors()
  clearPasswordErrors()

  // 表单验证
  let isValid = true

  accountError.value = validateAccount(accountLoginForm.account)
  if (accountError.value) isValid = false

  passwordError.value = validatePassword(accountLoginForm.password)
  if (passwordError.value) isValid = false

  if (!isValid) return

  try {
    loading.value = true

    const response = await request.post('/auth/login/account', {
      account: accountLoginForm.account,
      password: accountLoginForm.password,
      type: '1',
      sin: ''
    });

    if (response.code === '200') {
      const {token, hasBoundPhone} = response.data;

      // 确保token存储完成
setToken( token)
      console.log('Token存储完成:', localStorage.getItem('auth_token'));


      // 等待用户信息加载完成
      await new Promise(resolve => setTimeout(resolve, 500));

      if (hasBoundPhone) {
        ElMessage.success('登录成功');
        const redirectPath = getRedirectPath();
        console.log('准备跳转到:', redirectPath);
        clearRedirectPath();
        router.push(redirectPath);
      } else {
        // 跳转绑定手机页面，同时传递重定向路径
        const redirectPath = getRedirectPath();
        router.push({
          path: '/bind-phone',
          query: {
            token: token,
            redirect: redirectPath // 传递重定向路径
          }
        });
      }
    } else {
      ElMessage.error(response.message || '登录失败');
    }
  } catch (error) {
    // 处理错误：根据后端返回消息决定是否清空密码框
    const msg = error.response?.data?.message || error.message || '登录失败';
    // 如果错误信息涉及密码，清空密码框并设置密码错误提示
    if (msg.includes('密码') || msg.includes('账号或密码') || msg.includes('用户名或密码')) {
      passwordError.value = msg;
      accountLoginForm.password = ''; // 清空密码框
    } else if (msg.includes('账号') || msg.includes('用户名')) {
      accountError.value = msg;
      accountLoginForm.password = ''; // 清空密码框
    } else {
      ElMessage.error(msg);
    }
    console.error('登录错误:', error);
  } finally {
    loading.value = false
  }
}

// 处理手机登录
const handlePhoneLogin = async () => {

  if (!agreeToTerms.value) {
    ElMessage.error('请先阅读并同意用户协议和隐私政策')
    return
  }

  // 清除之前的错误信息
  clearPhoneErrors()
  clearCaptchaErrors()

  // 表单验证
  let isValid = true

  phoneError.value = validatePhone(phoneLoginForm.phone)
  if (phoneError.value) isValid = false

  captchaError.value = validateCaptcha(phoneLoginForm.captcha)
  if (captchaError.value) isValid = false

  if (!isValid) return

  try {
    loading.value = true

    const response = await request.post('/auth/login/phone', {
      phone: phoneLoginForm.phone,
      verifyCode: phoneLoginForm.captcha,
      type: '1',
      sin: ''
    })

    if (response.code === '200') {
      const {token, hasBoundPhone} = response.data;
      console.log("后端传回", token)

      // 确保token存储完成
setToken( token)
      console.log('Token存储完成:', localStorage.getItem('auth_token'));


      // 等待用户信息加载完成
      await new Promise(resolve => setTimeout(resolve, 500));

      ElMessage.success('登录成功')
      const redirectPath = getRedirectPath();
      clearRedirectPath();
      router.push(redirectPath);
    } else {
      ElMessage.error(response.message || '登录失败')
    }
  } catch (error) {

    if (error.response.data.message) {
      if (error.response.data.message.includes('校验码')) {
        captchaError.value = '校验码已过期，请重新获取'
      } else if (error.response.data.message.includes('验证码')) {
        captchaError.value = '验证码错误，请重新输入'
      } else if (error.response.data.message.includes('手机')) {
        phoneError.value = '该手机号未注册'
      } else {
        ElMessage.error(error.message)
      }
    }

    console.error('登录错误:', error.response.data)
  } finally {
    loading.value = false
  }
}

// 发送手机验证码
const sendCaptcha = async () => {
  // 清除之前的错误信息
  clearPhoneErrors()
  clearCaptchaErrors()

  // 验证手机号
  phoneError.value = validatePhone(phoneLoginForm.phone)
  if (phoneError.value) return

  try {
    const response = await request.get('/auth/verify-code/phone', {
      params: {
        phone: phoneLoginForm.phone,
        scene: 'Login' // 指定登录场景
      }
    })

    if (response.code === '200') {
      startCountdown(captchaCooldown, 60)
      captchaSuccess.value = '短信验证码已发送，可能会有延后，请耐心等待'
    } else {
      ElMessage.error(response.message || '验证码发送失败')
      console.log(response)
    }
  } catch (error) {
    ElMessage.error('验证码发送错误: ' + (error.response?.data?.message || error.message))
  }
}

// 处理微信登录
const handleWechatLogin = async () => {
  if (isWechatLoginLoading.value) return;

  isWechatLoginLoading.value = true;

  try {
    // console.log('开始微信登录，当前轮询状态:', pollingTimer);

    // 先清理所有现有的轮询
    clearAllPolling();

    // 重置过期状态
    isQrCodeExpired.value = false;

    // 切换到微信登录方式
    loginMethod.value = 'wechat';

    // 重置状态
    wechatQrCodeUrl.value = '';
    wechatQrError.value = '';

    // 获取二维码和sessionId
    const response = await request.get('/auth/wechat/mp-qrcode');
    const {qrUrl, sessionId} = response.data;

    wechatQrCodeUrl.value = qrUrl;
    currentSessionId.value = sessionId;

    // 记录当前活跃的session
    activePollingSessions.value.add(sessionId);

    // 启动轮询检查登录状态
    startPolling();
  } catch (error) {
    console.error('获取二维码失败:', error);
    const raw = error?.response?.data?.message || error?.message || '';
    wechatQrError.value = /AccessToken|appid|微信服务号/i.test(raw)
      ? '测试环境暂未配置微信服务号，请使用账号密码登录'
      : (raw || '微信登录暂不可用，请使用账号密码登录');
  } finally {
    isWechatLoginLoading.value = false;
  }
};

// 重新生成二维码
const refreshQrCode = () => {
  handleWechatLogin();
};

// 启动轮询
const startPolling = () => {
  clearPolling(); // 先清理之前的轮询

  const poll = async () => {
    // 多重检查确保应该停止轮询
    if (loginMethod.value !== 'wechat' || !activePollingSessions.value.has(currentSessionId.value)) {
      // console.log('轮询条件不满足，停止轮询');
      clearPolling();
      return;
    }

    try {
      const statusRes = await request.get('/auth/wechat/login/status', {
        params: {sessionId: currentSessionId.value}
      });

      const responseData = statusRes.data || {};

      // console.log('轮询响应:', responseData.status);

      if (responseData.status === 'success') {
        const token = responseData.token;
        const hasBoundPhone = responseData.hasBoundPhone;

        try {
setToken( token)
          console.log('Token 存储成功:', localStorage.getItem('auth_token'));


          // 等待用户信息加载完成
          await new Promise(resolve => setTimeout(resolve, 500));

          if (hasBoundPhone) {
            ElMessage.success('微信登录成功');
            clearAllPolling();
            const redirectPath = getRedirectPath();
            clearRedirectPath();
            router.push(redirectPath);
          } else {
            bindPhoneDialogVisible.value = true;
          }
        } catch (error) {
          console.error('Token 存储失败:', error);
          ElMessage.error('登录状态保存失败，请重试');
          return;
        }
      } else if (responseData.status === 'waiting_bind') {
        // 显示绑定手机弹窗
        bindPhoneDialogVisible.value = true;
      } else if (responseData.status === 'expired' || responseData.status === null) {
        // ！！！重要：会话过期时停止轮询！！！
        console.log('会话过期，停止轮询');
        isQrCodeExpired.value = true;
        clearAllPolling(); // 立即停止轮询
      } else if (responseData.status === 'waiting') {
        // 继续轮询，但添加额外检查
        if (loginMethod.value === 'wechat' && activePollingSessions.value.has(currentSessionId.value)) {
          pollingTimer = setTimeout(poll, 2000);
        } else {
          clearPolling();
        }
      }
    } catch (error) {
      console.error('轮询错误:', error);
      // 发生错误时也考虑停止轮询
      if (loginMethod.value === 'wechat' && activePollingSessions.value.has(currentSessionId.value)) {
        pollingTimer = setTimeout(poll, 2000);
      } else {
        clearPolling();
      }
    }
  };

  pollingTimer = setTimeout(poll, 2000);
  // console.log('启动轮询，定时器ID:', pollingTimer);
}

// 绑定成功处理
const handleBindSuccess = () => {
  ElMessage.success('绑定成功！')
  clearAllPolling();


  // 等待用户信息加载完成后再跳转
  setTimeout(() => {
    const redirectPath = getRedirectPath();
    clearRedirectPath();
    router.push(redirectPath);
  }, 500);
}

// 重定向路径的辅助函数
const getRedirectPath = () => {
  return sessionStorage.getItem('redirect_path') || route.query.redirect || '/home';
};

const clearRedirectPath = () => {
  sessionStorage.removeItem('redirect_path');
};

// 监听登录方式变化，重置同意状态和清理轮询
watch(loginMethod, (newVal, oldVal) => {
  if (oldVal === 'wechat' && newVal !== 'wechat') {
    clearAllPolling();
  }
  if (newVal !== oldVal) {
    agreeToTerms.value = false;
    agreeError.value = false;

    // ---------- 重置账号登录表单 ----------
    accountLoginForm.account = '';
    accountLoginForm.password = '';
    accountError.value = '';
    passwordError.value = '';

    // ---------- 重置手机登录表单 ----------
    phoneLoginForm.phone = '';
    phoneLoginForm.captcha = '';
    phoneError.value = '';
    captchaError.value = '';
    captchaSuccess.value = '';
    // 重置验证码倒计时（如果有倒计时，应清零）
    captchaCooldown.value = 0;
  }
});

// 路由离开时清理
onBeforeRouteLeave((to, from) => {
  if (from.name === 'login') {
    // console.log('离开登录页，清理轮询');
    clearAllPolling();
  }
});

// 组件销毁时彻底清理
onBeforeUnmount(() => {
  // console.log('组件即将销毁，清理轮询');
  clearAllPolling();
});

onUnmounted(() => {
  // console.log('组件已销毁，确保轮询清理');
  clearAllPolling();
});

</script>
<style scoped lang="scss">
/* ---------- 错误 / 成功提示 (现代 alert 风格) ---------- */
.error-message {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #dc2626;
  font-size: 11px;
  margin-top: 6px;
  padding: 0;                      /* 显式重置内边距 */
  line-height: 1;                 /* 消除行高带来的额外间距 */
  animation: fadeInUp 0.3s ease;

  .el-icon {
    font-size: 12px;
    flex-shrink: 0;
    line-height: 1;               /* 图标也紧凑 */
  }
}

.success-message {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #16a34a;
  font-size: 11px;
  margin-top: 6px;
  padding: 0;                      /* 显式重置内边距 */
  line-height: 1;                 /* 消除行高带来的额外间距 */
  animation: fadeInUp 0.3s ease;

  .el-icon {
    font-size: 12px;
    flex-shrink: 0;
    line-height: 1;               /* 图标也紧凑 */
  }
}

/* ---------- 根容器 (粘性底部) ---------- */
.login-page-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  background: radial-gradient(ellipse 900px 700px at 12% 5%, rgba(47, 91, 255, 0.12), transparent 60%),
  radial-gradient(ellipse 800px 600px at 88% 8%, rgba(245, 158, 11, 0.08), transparent 55%),
  radial-gradient(ellipse 700px 500px at 50% 100%, rgba(47, 91, 255, 0.05), transparent 55%),
  #f7f9fc;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  overflow-x: hidden;
}

/* ---------- 装饰背景光晕层 ---------- */
.bg-glow-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;

  .bg-blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.5;
    animation: floatBlob 18s ease-in-out infinite;
  }

  .bg-blob-blue {
    width: 520px;
    height: 520px;
    top: -120px;
    left: -100px;
    background: radial-gradient(circle, rgba(47, 91, 255, 0.45), transparent 70%);
  }

  .bg-blob-orange {
    width: 460px;
    height: 460px;
    top: 10%;
    right: -120px;
    background: radial-gradient(circle, rgba(245, 158, 11, 0.4), transparent 70%);
    animation-delay: -6s;
  }

  .bg-grid-overlay {
    position: absolute;
    inset: 0;
    background-image: linear-gradient(rgba(47, 91, 255, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(47, 91, 255, 0.04) 1px, transparent 1px);
    background-size: 48px 48px;
    mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 75%);
    -webkit-mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 75%);
  }
}

/* ---------- 主内容区 (登录卡片居中偏右) ---------- */
.main-content {
  background: transparent;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;    /* 靠右对齐 */
  flex: 1;              /* 不收缩，撑开可用空间 */
  box-sizing: border-box;
  padding: 0 10% 0 0;     /* 右侧保留 5% 安全间距，避免卡片贴边 */
}

.auth-split-shell {
  display: block;
  width: 100%;
  max-width: 380px;            /* 适当缩小卡片宽度 */
  margin-right: 0;             /* 取消自动外边距，跟随父容器右对齐 */
}

/* ---------- 右侧登录表单卡片 ---------- */
.login-form-container {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;

  .login-card {
    width: 100%;
    max-width: 100%;
    overflow: visible;
    border: 1px solid rgba(226, 232, 240, 0.9);
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(20px);
    box-shadow: 0 20px 50px rgba(15, 23, 42, 0.1),
    0 6px 20px rgba(47, 91, 255, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
    position: relative;
    padding: 0;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);

    &:hover {
      box-shadow: 0 24px 60px rgba(15, 23, 42, 0.14),
      0 8px 28px rgba(47, 91, 255, 0.12);
    }

    :deep(.el-card__body) {
      padding: 0 !important;
      border-radius: 20px;
      overflow: hidden;
    }
  }
}

/* 关闭按钮 - 现代圆形玻璃按钮 */
.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  color: #64748b;
  z-index: 10;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    color: #dc2626;
    background: rgba(220, 38, 38, 0.08);
    border-color: rgba(220, 38, 38, 0.2);
    transform: rotate(90deg) scale(1.05);
    box-shadow: 0 6px 16px rgba(220, 38, 38, 0.18);
  }
}

/* 表单主体 */
.login-body {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
}

.login-form-wrapper {
  flex: 1;
  padding: 28px 26px 20px;      /* 稍紧凑 */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: auto;
}

/* ---------- 登录头部 (渐变文字) ---------- */
.login-header {
  margin-bottom: 20px;
  text-align: left;

  .header-eyebrow {
    display: inline-block;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #2f5bff;
    background: rgba(47, 91, 255, 0.08);
    padding: 4px 12px;
    border-radius: 999px;
    border: 1px solid rgba(47, 91, 255, 0.15);
    margin-bottom: 10px;
  }

  h3 {
    font-size: 1.6rem;
    font-weight: 800;
    margin: 0 0 6px;
    background: linear-gradient(135deg, #0f172a 0%, #142c84 55%, #1f43cc 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: -0.5px;
    line-height: 1.2;
  }

  .header-sub {
    margin: 0;
    font-size: 0.88rem;
    color: #64748b;
    font-weight: 400;
  }
}

/* ---------- 登录表单 ---------- */
.login-form {
  min-height: 220px;
  margin: 0 !important;
  flex-direction: column;
  justify-content: center;
}

/* 表单项目间距 */
:deep(.el-form-item) {
  margin-bottom: 14px;
}

/* ---------- 优雅输入框 (圆角 12px + focus 蓝光) ---------- */
.login-elegant-input {
  :deep(.el-input__wrapper) {
    border-radius: 12px;
    padding: 4px 14px;
    box-shadow: 0 0 0 1px rgba(226, 232, 240, 0.9) inset;
    background: rgba(248, 250, 252, 0.6);
    height: 32px;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

    &:hover {
      box-shadow: 0 0 0 1px rgba(47, 91, 255, 0.4) inset;
      background: #ffffff;
    }

    &.is-focus {
      box-shadow: 0 0 0 1px #2f5bff inset,
      0 0 0 4px rgba(47, 91, 255, 0.12) !important;
      background: #ffffff;
    }
  }

  :deep(.el-input__prefix) {
    left: 12px;
    color: #2f5bff;
    font-size: 16px;
  }

  :deep(.el-input__suffix) {
    display: flex;
    align-items: center;
    padding-right: 10px;
  }

  :deep(.el-input__inner) {
    padding-right: 80px;
    color: #0f172a;
    font-size: 14px;

    &::placeholder {
      color: #94a3b8;
    }
  }

  .captcha-btn {
    padding: 6px 12px;
    height: auto;
    color: #1f43cc;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    margin-left: 4px;
    border-radius: 8px;
    background: rgba(47, 91, 255, 0.08);
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      color: #1836a8;
      background: rgba(47, 91, 255, 0.14);
    }

    &:disabled {
      color: #94a3b8;
      cursor: not-allowed;
      background: rgba(148, 163, 184, 0.1);
    }
  }

  :deep(input) {
    font-size: 13px;
    height: 28px;
    line-height: 28px;

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: #0f172a !important;
      -webkit-box-shadow: 0 0 0px 1000px rgba(248, 250, 252, 0.6) inset !important;
      transition: background-color 5000s ease-in-out 0s;
      caret-color: #0f172a;
    }
  }
}

/* ---------- 忘记密码链接 ---------- */
.login-footer-link {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 6px;

  .el-link {
    font-size: 13px;
    color: #64748b;
    transition: all 0.3s ease;
    font-weight: 500;

    &:hover {
      color: #1f43cc;
    }
  }
}

/* ---------- 登录按钮 (蓝色渐变 + 光晕 + hover 上浮) ---------- */
.login-btn {
  width: 100%;
  margin-top: 8px;
  border-radius: 12px;
  padding: 0 16px;
  font-weight: 700;
  letter-spacing: 3px;
  font-size: 14px;
  height: 42px;
  border: none;
  background: linear-gradient(135deg, #2f5bff 0%, #5b7cff 100%) !important;
  box-shadow: 0 8px 20px rgba(47, 91, 255, 0.35),
  inset 0 1px 0 rgba(255, 255, 255, 0.2);
  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.25), transparent);
    transition: left 0.6s ease;
  }

  &:hover:not(.is-loading) {
    transform: translateY(-2px);
    box-shadow: 0 14px 28px rgba(47, 91, 255, 0.42),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);

    &::before {
      left: 100%;
    }
  }

  &:active:not(.is-loading) {
    transform: translateY(0);
  }
}

/* ---------- 微信登录容器 ---------- */
.wechat-login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 0 12px;
  position: relative;

  /* 正常二维码 */
  .wechat-qrcode {
    text-align: center;
    margin-bottom: 12px;

    img {
      width: 200px;
      height: 200px;
      display: block;
      margin: 0 auto;
      padding: 14px;
      background: #ffffff;
      border-radius: 20px;
      box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08),
      0 0 0 1px rgba(226, 232, 240, 0.8),
      0 0 0 6px rgba(76, 191, 0, 0.08);
      transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);

      &:hover {
        transform: translateY(-2px) scale(1.01);
        box-shadow: 0 18px 40px rgba(15, 23, 42, 0.1),
        0 0 0 1px rgba(226, 232, 240, 0.8),
        0 0 0 8px rgba(76, 191, 0, 0.12);
      }
    }

    .tip {
      margin-top: 16px;
      color: #475569;
      font-size: 13.5px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;

      &::before {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #22c55e;
        box-shadow: 0 0 8px rgba(34, 197, 94, 0.6);
        animation: glowPulse 1.8s ease-in-out infinite;
      }
    }
  }

  /* 加载占位 */
  .loading-qrcode {
    padding: 80px 0;
    color: #64748b;
    font-size: 14px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &::before {
      content: '';
      width: 14px;
      height: 14px;
      border: 2px solid rgba(47, 91, 255, 0.2);
      border-top-color: #2f5bff;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }
  }

  .qr-error {
    padding: 60px 16px;
    text-align: center;

    p {
      margin: 0 0 8px;
      color: #64748b;
      font-size: 14px;
      line-height: 1.6;
    }
  }
}

/* ---------- 二维码过期 ---------- */
.qr-expired-prompt {
  display: flex;
  justify-content: center;
}

.expired-qrcode {
  background: transparent;
  position: relative;
  width: 228px;
  height: 228px;
  margin: 0 auto;
}

.expired-img {
  width: 200px;
  height: 200px;
  display: block;
  margin: 14px auto 0;
  padding: 0;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
  opacity: 0.4;
  filter: grayscale(100%);
}

.expired-mask {
  position: absolute;
  top: 14px;
  left: 14px;
  right: 14px;
  bottom: 14px;
  background: rgba(248, 250, 252, 0.65);
  border: 1px solid rgba(226, 232, 240, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(248, 250, 252, 0.96);

  }

}

.expired-content {
  text-align: center;
  padding: 16px;
}

.expired-icon {
  font-size: 36px !important;
  color: #f59e0b !important;
  margin-bottom: 8px;
  filter: drop-shadow(0 4px 12px rgba(245, 158, 11, 0.3));
}

.expired-text {
  font-size: 14px !important;
  color: #d40c0c !important;
  margin: 0;
  font-weight: 500;
}

.refresh-btn {
  padding: 8px 18px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 13px;
  height: auto;
  background: linear-gradient(135deg, #2f5bff 0%, #5b7cff 100%) !important;
  border: none;
  box-shadow: 0 6px 16px rgba(47, 91, 255, 0.3);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(47, 91, 255, 0.4);
  }
}

.expired-img {
  width: 200px;
  height: 200px;
  display: block;
  margin: 0 auto;
  padding: 14px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
}

/* ---------- 注册链接 ---------- */
.register-link {
  text-align: center;
  font-size: 13.5px;
  padding: 12px 0;
  margin-top: 4px;
  border-bottom: 1px dashed rgba(226, 232, 240, 0.9);

  span {
    color: #64748b;
    vertical-align: middle;
  }

  .el-link {
    font-size: 13.5px;
    vertical-align: middle;
    font-weight: 600;
  }
}

/* ---------- 登录方式选择 (圆形玻璃按钮) ---------- */
.login-method-wrapper {
  margin-top: 16px;
  margin-bottom: 4px;
}

.login-method-container {
  background-color: transparent;
  border-radius: 12px;
  padding: 0;
  box-shadow: none;
  border: none;
}

.login-method-label {
  text-align: center;
  font-size: 11px;
  color: #94a3b8;
  letter-spacing: 1px;
  font-weight: 500;
  margin: 4px 0 10px;
}

.login-method-tabs {
  display: flex;
  justify-content: center;
  gap: 14px;
  position: relative;
  border-bottom: none;
  margin-bottom: 0;

  .method-button {
    position: relative;
    padding: 0 !important;
    margin: 0 !important;
    border: 1px solid rgba(226, 232, 240, 0.9) !important;
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(8px);
    height: 48px !important;
    width: 48px !important;
    border-radius: 50% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
    transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(135deg, rgba(47, 91, 255, 0.12), rgba(245, 158, 11, 0.12));
      opacity: 0;
      transition: opacity 0.35s ease;
      border-radius: 50%;
    }

    &.icon-only {
      .method-text {
        display: none;
      }
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 10px 24px rgba(47, 91, 255, 0.18);
      border-color: rgba(47, 91, 255, 0.3) !important;

      &::before {
        opacity: 1;
      }

      svg {
        transform: scale(1.08);
      }
    }

    svg {
      transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1);
      position: relative;
      z-index: 1;
    }

    .method-icon {
      width: 28px;
      height: 28px;
    }
  }
}

/* ---------- 协议复选框 (现代风格 + 蓝色强调) ---------- */
.agreement {
  text-align: center;
  font-size: 12.5px;
  color: #64748b;
  margin-top: 12px;
  line-height: 1.7;
  padding: 4px 6px;

  .agreement-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;

    .agree-checkbox {
      margin-right: 4px;
      height: auto;

      :deep(.el-checkbox__input) {
        .el-checkbox__inner {
          border-radius: 6px;
          width: 16px;
          height: 16px;
          border-color: #cbd5e1;
          transition: all 0.25s ease;

          &:hover {
            border-color: #2f5bff;
          }
        }

        &.is-checked .el-checkbox__inner {
          background: linear-gradient(135deg, #2f5bff, #5b7cff);
          border-color: #2f5bff;
          box-shadow: 0 2px 6px rgba(47, 91, 255, 0.3);
        }
      }

      :deep(.el-checkbox__label) {
        cursor: default;
        user-select: none;
        font-size: 12.5px;
        color: #475569;
        padding-left: 8px;
      }
    }

    .agreement-links {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .el-link {
      font-size: 12.5px;
      vertical-align: baseline;
      font-weight: 500;
      transition: all 0.25s ease;

      &:hover {
        color: #1f43cc;
      }
    }

    span {
      color: #94a3b8;
      font-size: 12.5px;
    }
  }
}

/* ---------- 底部 footer (深色渐变 + 蓝橙光晕) ---------- */
.login-footer {
  position: relative;
  color: #475569;
  flex-shrink: 0;               /* 不收缩，保持高度 */
  padding: 16px 24px 12px;     /* 确保内容有空间显示 */
  border-top: 1px solid rgba(226, 232, 240, 0.8);
  overflow: hidden;
  background: linear-gradient(
          135deg,
          #e8edf2 0%,
          #f2f0f2 45%,
          #f8f4f0 100%
  );

  .footer-glow {
    display: none;
  }

  .footer-content {
    position: relative;
    z-index: 1;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 62px 62px;
  }

  .footer-sections {
    background: transparent;
    display: grid;
    grid-template-columns: 1.5fr 1fr; /* 保持原有列数，但只留两列 */
    gap: 42px;                    /* 减小间距 */
    margin-bottom: 10px;          /* 原 28px，减小 */

  }

  .footer-section:first-child {
    padding-right: 10px;
  }

  .footer-logo {
    display: flex;
    align-items: center;

    margin-bottom: 8px;
  }

  .footer-logo-mark {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: linear-gradient(135deg, #2f5bff 0%, #f59e0b 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 800;
    color: #fff;
    box-shadow: 0 4px 12px rgba(47, 91, 255, 0.3);
  }

  .footer-logo-text {
    font-size: 1.2rem;
    font-weight: 700;
    color: #1e293b;
    background: linear-gradient(135deg, #2f5bff, #f59e0b);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .footer-desc {
    background: transparent;
    color: #64748b;
    line-height: 1.7;
    font-size: 0.88rem;
    margin: 0;
  }

  .section-title {
    color: #1e293b;
    font-size: 1rem;
    font-weight: 700;
    margin: 0 0 8px;
    position: relative;
    display: inline-block;
  }


  .contact-info {
   background: transparent;
    display: flex;
    line-height: 1.7;
    flex-direction: row;          /* 改为水平排列 */
    flex-wrap: wrap;             /* 小屏自动换行 */
    gap: 16px 24px;              /* 行间距和列间距 */
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 6px;                    /* 图标与文字间距减小 */
    font-size: 0.85rem;
    white-space: nowrap;         /* 文字不换行，保持一行 */

    &:hover {
      color: #1e293b;
    }
  }

  .contact-item .el-icon {
    color: #f59e0b;
    font-size: 1rem;
  }

  .footer-bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px 16px;
    padding-top: 8px;
    border-top: 1px solid rgba(141, 143, 146, 0.6);
  }

  .copyright-section {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .copyright-text {
    font-size: 0.8rem;
    color: #94a3b8;
  }

  .legal-links {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .legal-link {
    color: #94a3b8;
    text-decoration: none;
    font-size: 0.82rem;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      color: #1f43cc;
    }
  }

  .divider {
    color: #cbd5e1;
    font-size: 0.78rem;
  }

  .certification-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .beian-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .beian-icon {
    height: 16px;
    width: auto;
    filter: brightness(0.9);
  }

  .beian-link,
  .icp-link {
    color: #94a3b8;
    text-decoration: none;
    font-size: 0.78rem;
    transition: color 0.3s ease;

    &:hover {
      color: #1f43cc;
    }
  }
}

/* ---------- 政策弹窗 (圆角 20px + 渐变头部) ---------- */
.policy-dialog {
  :deep(.el-dialog) {
    width: 560px !important;
    max-width: 92%;
    border-radius: 20px;
    overflow: hidden;
    max-height: 84vh;
    display: flex;
    flex-direction: column;
    margin-top: 8vh !important;
    box-shadow: 0 32px 64px rgba(15, 23, 42, 0.25),
    0 12px 24px rgba(47, 91, 255, 0.12);
    border: 1px solid rgba(226, 232, 240, 0.9);
  }

  :deep(.el-dialog__header) {
    padding: 0;
    margin: 0;
    border-bottom: none;
    position: relative;
    background: radial-gradient(ellipse 400px 200px at 10% 0%, rgba(47, 91, 255, 0.14), transparent 70%),
    radial-gradient(ellipse 400px 200px at 90% 0%, rgba(245, 158, 11, 0.1), transparent 70%),
    linear-gradient(135deg, #f7f9fc 0%, #ffffff 100%);
    border-bottom: 1px solid rgba(226, 232, 240, 0.9);

    .dialog-header {
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 22px 26px;

      .dialog-header-icon {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        background: linear-gradient(135deg, #2f5bff, #5b7cff);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 20px rgba(47, 91, 255, 0.3);
        flex-shrink: 0;
      }

      h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #0f172a;
        line-height: 1.3;
      }

      p {
        margin: 4px 0 0;
        font-size: 12.5px;
        color: #64748b;
      }
    }
  }

  :deep(.el-dialog__body) {
    padding: 0;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  :deep(.el-dialog__footer) {
    padding: 14px 24px;
    border-top: 1px solid rgba(226, 232, 240, 0.9);
    background: #f7f9fc;
  }

  :deep(.el-dialog__headerbtn) {
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(8px);
    transition: all 0.3s ease;

    &:hover {
      background: rgba(220, 38, 38, 0.1);

      .el-dialog__close {
        color: #dc2626;
      }
    }
  }
}

.dialog-content {
  flex: 1;
  overflow-y: auto;
  line-height: 1.75;
  color: #475569;
  padding: 22px 26px;
  max-height: 56vh;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.35);
    border-radius: 3px;

    &:hover {
      background: rgba(47, 91, 255, 0.4);
    }
  }

  h2 {
    color: #0f172a;
    margin: 0 0 12px;
    padding-bottom: 12px;
    border-bottom: 2px solid transparent;
    border-image: linear-gradient(90deg, #2f5bff, #f59e0b) 1;
    font-size: 1.35em;
    font-weight: 700;
  }

  h3 {
    color: #1e293b;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 1.05em;
    font-weight: 700;
    padding-left: 10px;
    border-left: 3px solid #2f5bff;
  }

  p,
  ul {
    margin-bottom: 12px;
    font-size: 14px;
  }

  ul {
    padding-left: 20px;

    li {
      margin-bottom: 6px;
    }
  }

  strong {
    color: #1e293b;
    font-weight: 600;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;

  :deep(.el-button--primary) {
    background: linear-gradient(135deg, #2f5bff, #5b7cff);
    border: none;
    border-radius: 10px;
    padding: 9px 22px;
    font-weight: 600;
    box-shadow: 0 6px 16px rgba(47, 91, 255, 0.3);

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 8px 20px rgba(47, 91, 255, 0.4);
    }
  }
}

/* ---------- 关键帧动画 ---------- */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes glowPulse {
  0%, 100% {
    opacity: 0.45;
  }
  50% {
    opacity: 1;
  }
}

@keyframes floatBlob {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(20px, -30px) scale(1.05);
  }
  66% {
    transform: translate(-15px, 20px) scale(0.95);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 入场动画 */
.login-form-container {
  animation: fadeInUp 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
  animation-delay: 0.1s;
}

/* ---------- 响应式 ---------- */
@media (max-width: 1024px) {
  .auth-split-shell {
    max-width: 420px;
  }

  .main-content {
    padding: 0 5% 0 0;
    justify-content: center;
  }

  .login-form-container .login-card {
    max-width: 100%;
    border-radius: 18px;
  }
}

@media (max-width: 768px) {

  .login-page-wrapper {
    min-height: 100vh;
    height: auto;
  }

  .main-content {
    padding: 24px 16px;
    justify-content: center;
    flex: none;
    min-height: auto;
  }

  .auth-split-shell {
    max-width: 100%;              /* 移动端宽度自适应 */
    padding-right: 0;
  }

  .login-form-wrapper {
    padding: 20px 16px 16px;
  }

  .login-header {
    text-align: center;
    margin-bottom: 22px;

    .header-eyebrow {
      font-size: 0.72rem;
    }

    h3 {
      font-size: 1.6rem;
    }

    .header-sub {
      font-size: 0.82rem;
    }
  }

  .login-elegant-input {
    :deep(.el-input__wrapper) {
      height: 44px;
    }
  }

  .login-btn {
    height: 44px;
    font-size: 14px;
    letter-spacing: 3px;
  }

  .login-footer {
    padding: 8px 12px 6px;
    position: relative;
  }

  .login-footer .footer-content {
    padding: 12px 0;
  }
  .login-footer .footer-sections {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 8px;
    padding-bottom: 0;
    border-bottom: none;         /* 去掉分割线，节省空间 */
  }
  .login-footer .footer-bottom {
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding-top: 4px;
    border-top: 1px solid rgba(226, 232, 240, 0.6);
  }
  .login-footer .contact-info {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px 16px;
  }
  .login-footer .certification-info {
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
  .login-footer .beian-container {
    justify-content: center;
  }
  .login-footer .copyright-text {
    font-size: 0.75rem;
  }
  .login-footer .beian-link,
  .login-footer .icp-link {
    font-size: 0.7rem;
  }

}

@media (max-width: 480px) {
  .auth-split-shell {
    max-width: 100%;
  }

  .login-form-wrapper {
    padding: 16px 12px 14px;
  }

  .login-header h3 {
    font-size: 1.3rem;
  }

  .login-method-tabs {
    gap: 10px;

    .method-button {
      width: 44px !important;
      height: 44px !important;
    }
  }

  .wechat-login-container .wechat-qrcode img {
    width: 180px;
    height: 180px;
  }
}

/* 笔记本屏幕 (1024px - 1366px) */
@media (max-width: 1366px) and (min-width: 1025px) {
  .auth-split-shell {
    max-width: 400px;
  }

  .login-form-wrapper {
    padding: 34px 30px 28px;
  }
}
</style>
